const URL = process.env.REACT_APP_URL;
const APIKEY = process.env.REACT_APP_API_KEY;
const CONTENTTYPE = "application/json";

export { URL, APIKEY, CONTENTTYPE };
